import { EntityDto, IEntityDto } from "../../../utils/models/entity-dto";
import { FieldType } from "@gbs-platform-client/fwk-core";
import { NumberLiteralType } from "typescript";
import { Act } from "./act";
import { committeemember } from "./committeemember";
import { committeepermenantInvitees } from "./committeepermenantInvitees";
import { Employee } from "./employee";
import { committeesecratary } from "./committeesecratary";
import { committeeChairman } from "./committeechairman";
import { Department } from "./department";


export class Committee extends EntityDto implements IEntityDto {
  Committee_Id: string;
  CommitteeName: string;
  ShortName: string;
  CommitteePrefix: string;
  DateOfFormation: Date;
  Department_Id: string;
  MeetingType_Id: string;
  DepartmentName: string;
  SecretaryJoiningDateStr: string
  reviewrDepartmentName: string;
  SecretaryName: string;
  IsActive: boolean;
  ContinuousNumbering:boolean;
  Emp_Ref_Id: string;
  EmployeeName: string;
  TotalCount: number;
  DisplayValue: number;
  QuorumOptionValue: string;
  JoiningDate: Date;
  Tittle: string;
  Till: string;
  QuorumOptions_Id: number;
  QuorumValue: Number;
  Secretary_Emp_Ref_Id: string|undefined;
  SecretaryJoiningDate: Date | undefined = undefined;
  SecretaryInChargeTill_Id: number;
  SecretaryInChargeTillDate: Date | undefined;
  PermenantInviteeInChargeTillDate: Date | null;
  Secretaryflag: number;
  SecretaryInChargeTillTenure: number;
  secretary_exipirytenure: number;
  SecretaryTenureDate: string | null = '';
  PermenantInviteeInChargeTillTenure: number;
  Chairman_Emp_Ref_Id: string|undefined;
  ChairmanJoiningDate: Date | undefined = undefined;
  ChairmanInChargeTill_Id: number;

  ChairmanInChargeTillDate: Date | undefined;
  ChairmanInChargeTillTenure: number;
  ChairmanName: string;
  isChecked: boolean = false;

  ChairmanEditBit: number;
  SecretaryEditBit:number;

  Member_Emp_Ref_Id: string;
  MemberJoiningDate: Date;
  MemberInChargeTill_Id: number;
  PermenantInviteeInChargeTill_Id: number;
  MemberInChargeTillDate: Date;
  MemberInChargeTillTenure: number;
  Membername: string;
  MembershipExpiryType: string;
  MembershipExpiry: number;
  Document: any;
  Document_Name: string;
  FileName: string;
  Ref_Id: string | null;
  docTittle:string;
  // MeetingType_Id: string;
  MeetingTypeName: string;
  Invitee_Type_Id: string;
  Organizer: Array<Employee>;
  multidepartment :Array<Department>;
  Act_Id: string
  ActName: string;
  InviteeTypeName: string
  Act: Array<Act>;
  ApermenantInvitees: Array<Employee>;
  Employee_inviteedata: Array<Employee>;
  lists: Array<any> = [];
  SittingFeeApplicable: boolean;
  Response_Committee_Id: string;
  SittingFee: number;
  MemberEditBit: number;
  InviteeEditBit: number;
  SittingFeeEffectiveFrom: Date | undefined;
  SittingFeeEffectiveTo: Date | undefined;
  committeememberarray: Array<committeemember>;
  Chairmanarray: Array<committeeChairman>
  secretaryarray: Array<committeesecratary>;
  permenantInviteesgrid: Array<committeepermenantInvitees>;
  constructor() {
    super();
    this.Committee_Id = '00000000-0000-0000-0000-000000000000';
    this.Response_Committee_Id = '00000000-0000-0000-0000-000000000000';
    this.CommitteeName = '';
    this.CommitteePrefix = '';
    this.DateOfFormation = new Date();
    this.Department_Id = '00000000-0000-0000-0000-000000000000';
    // this.MeetingType_Id='00000000-0000-0000-0000-000000000000';
    this.DepartmentName = '';
    this.SecretaryName = '';
    this.Emp_Ref_Id = '';
    this.EmployeeName = '';
    this.TotalCount = 0;
    this.IsActive = true;
    this.ContinuousNumbering = true;
    this.ShortName = "";
    this.DisplayValue = 0;
    this.QuorumOptionValue = '';
    this.Tittle = '';
    this.docTittle='';
    this.Till = '';
    this.JoiningDate = new Date();
    this.QuorumOptions_Id = 0;
    this.QuorumValue = 0;

    this.Secretary_Emp_Ref_Id = '';
    this. SecretaryEditBit=0;

    this.SecretaryInChargeTill_Id = 0;
    this.PermenantInviteeInChargeTill_Id = 0;
    this.SecretaryInChargeTillDate = undefined;
    this.PermenantInviteeInChargeTillDate = null;
    this.SecretaryInChargeTillTenure = 0;
    this.secretary_exipirytenure = 0;

    this.PermenantInviteeInChargeTillTenure = 0;
    this.Chairman_Emp_Ref_Id = '';
    this.ChairmanInChargeTill_Id = 0;
    this.ChairmanEditBit = 0;
    this.ChairmanInChargeTillTenure = 0;
    this.ChairmanName = '';
    this.MemberEditBit = 0;
    this.InviteeEditBit = 0;
    this.Member_Emp_Ref_Id = '';
    this.MemberJoiningDate = new Date();
    this.MemberInChargeTill_Id = 0;
    this.Secretaryflag = 1;
    this.MemberInChargeTillDate = new Date();
    this.MemberInChargeTillTenure = 0;
    this.Membername = '';
    this.MembershipExpiryType = '';
    this.MembershipExpiry = 0;
    this.reviewrDepartmentName = '';
    this.Document = null;
    this.Document_Name = "";
    this.FileName = "";
    this.Ref_Id = "";
    this.MeetingType_Id = '';
    this.MeetingTypeName = '';
    this.Invitee_Type_Id = '';
    this.Act_Id = '';
    this.InviteeTypeName = '';
    this.ActName = '';
    this.Act = [];
    this.Organizer = [];
    this.multidepartment = [];
    this.Employee_inviteedata = [];
    this.ApermenantInvitees = [];
    this.committeememberarray = [];
    this.SittingFeeApplicable = false;
    this.permenantInviteesgrid = [];
    this.Chairmanarray = [];
    this.secretaryarray = [];
    this.SittingFee = 0.00;
    this.SecretaryJoiningDateStr = '';
    this.EntityMetaData = [
      { FieldName: 'CommitteeName', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Meeting Type Name is required' },
      { FieldName: 'Department_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Department Name is required' },
      { FieldName: 'ShortName', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: ' Code is required' },
      { FieldName: 'MeetingType_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Meeting Group is required' },
      { FieldName: 'DateOfFormation', FieldType: FieldType.Date, IsMandatory: true, ValidationMessage: 'Date Of Formation is required' },
    ];
  }
}